import { PickerButtonGroup, PickerSection } from './_PickerSection';
import type { UserSelectionStep } from './types';

interface StepOptionPickerProps {
  step: UserSelectionStep;
  selectedIndex: number;
  onSelect: (index: number) => void;
  theme: 'dark' | 'light';
}

export function StepOptionPicker({ step, selectedIndex, onSelect, theme }: StepOptionPickerProps) {
  return (
    <PickerSection label={step.sectionLabel} theme={theme}>
      <PickerButtonGroup
        theme={theme}
        options={step.options.map((option, i) => ({
          key: option.label,
          label: option.label,
          isSelected: i === selectedIndex,
          onSelect: () => onSelect(i),
        }))}
      />
    </PickerSection>
  );
}
